import { useSearchParams } from 'react-router'

import { AccountBanner, AccountStage } from '../prototypes/AccountBanners/AccountBanner'

/**
 * One account banner rendered alone, for the prototype page to embed in a
 * phone-width iframe — `sm:` breakpoints resolve against the iframe's own
 * viewport, which is the only way to show the real mobile banner on a desktop page.
 */
export function AccountBannerFrame() {
  const [searchParams] = useSearchParams()
  const stage = (searchParams.get('stage') ?? AccountStage.APPLICATION_INCOMPLETE) as AccountStage

  // Matches the px-4 gutter the app's Container puts around the banner.
  return (
    <div className="p-4">
      <AccountBanner stage={stage} />
    </div>
  )
}
